module.exports = __webpack_public_path__ + "static/media/home.63634f68.svg";